var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFlexipassSalto = function SvgFlexipassSalto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 1280,
    viewBox: "0 0 2048 333"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M0 0h2048v333H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1384 0h664v333h-664z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1922 55h57l4 25 17 115v7h-28l-15-102-6-41h-1l-12 82-9 61h-28l1-13 13-89z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M720 69h48l12 3 10 5 7 7 5 10 1 5v15l-4 12-9 10-8 5-10 3-7 1h-23v40h-22l-1-1V70z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1787 116h20l12 4 9 6 7 8 5 12 1 5v18l-3 11-6 10-9 8-11 5-11 2h-8l-14-3-11-6-7-7-6-12-2-9v-16l3-12 7-11 8-7 8-4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M844 69h23l17 43 20 51 8 20v2h-21l-4-5-8-21v-2l-47 1-8 21-3 5-2 1h-21l11-29 21-53 11-28zM550 69h26l12 17 12 18h3l22-33 2-2h25l-2 5-27 40-7 10 1 5 16 24 15 22 6 9v1h-26l-16-23-10-15-1-1-26 39h-26l2-5 13-19 23-34-2-5-8-12-19-28-8-12zM461 69h74v18l-51 1-1 30h40l1 3v14l-1 1h-40l1 31h50l1 1v17h-74l-1-17V82z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1547 116h20l11 4 8 6 5 9 1 4 1 45 2 3 8 1v14h-17l-6-4-3-7h-2l-6 8-10 5-14 1-10-2-8-4-5-5-4-6-1-4v-12l3-8 7-7 10-4 5-1h33l-1-11-3-5v-2l-5-2-3-1h-13l-8 4-4 6-2 4-12-3-4-2 3-8 9-10 8-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1040 68h19l13 4 11 7-1 5-6 9-1 1-7-1-10-5-5-1h-7l-9 3-4 6v8l4 5 11 5 15 5 10 5 5 4 6 10 1 4v15l-4 11-7 9-9 6-9 3-8 1h-8l-14-3-14-7-6-5 2-5 6-8 1-1h6l14 8 4 1h12l8-4 3-4 1-3v-7l-3-6-10-5-21-7-9-6-6-7-3-8V95l3-9 7-9 9-6zM951 68h19l13 4 11 7-1 5-5 9-7 1-12-6-5-1h-7l-9 3-3 4-1 9 4 6 12 5 21 8 9 7 5 8 1 3v17l-4 11-6 8-10 7-9 3-16 1-14-3-12-6-7-5 1-6 6-8 1-1h6l12 7 6 2h12l9-4 3-6v-9l-4-6-12-5-18-6-9-6-5-6-4-10V95l4-10 6-8 10-6zM282 69h74v18h-51v33h43v18l-2 1-41-1v47h-23zM375 69h23v98h46v18h-69z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1457 116h20l12 4 9 8 4 8-1 4-15 4-4-9-7-4h-16l-5 3-2 4 1 6 4 4 11 3 18 4 10 4 6 5 4 10v8l-3 9-5 6-12 6-11 2h-9l-14-3-8-4-7-6-5-10-1-6 5-2 11-2 6 12 6 4 9 2 12-1 6-4 2-4-1-6-4-4-10-3-18-4-10-4-7-6-3-6v-15l4-7 7-6zM1615 76h25l8 4 4 8v100h25v14h-65v-14l22-1V95l-1-3-18-1zM1711 88h1v30h29v14l-2 1h-26v50l1 3 2 1 28 1v14h-37l-8-4-4-8v-57h-17l-1-1v-14h18V93z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M668 69h23v116h-23zM1791 131h12l10 4 7 8 3 7 1 5v10l-3 10-4 6-6 5-7 3h-14l-10-5-6-7-3-8v-18l4-10 8-7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M742 87h24l7 3 5 5 2 4v15l-5 8-7 4-4 1h-22z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M687 221h23l6 3 5 5 3 6v12l-4 8-6 5-6 2h-21zM303 221h7l13 16 7 9v-25h8v41h-6l-9-10-10-13-1-1-1 24h-8zM589 221h7l11 13 9 12v-25h8v41h-6l-7-8-10-13-3-4-1 25h-7l-1-1z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M854 93h2l17 47v1h-35l1-5 14-39z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M865 221h9l12 29 3 8v4h-7l-3-4-1-6h-17l-1 6-3 4h-8l3-9 12-30zM1543 166h32v8l-4 8-7 6-5 2h-15l-7-4-3-6 1-8 5-5zM769 220h10l8 4 2 3-4 4-6-2h-11l-5 5-1 2v10l3 6 3 2h13v-7h-7v-6h15v17l-8 4-9 1-8-2-6-4-5-7-1-4v-10l5-10 8-5zM523 220h10l9 4 1 4-3 3-7-2h-10l-5 4-2 10 3 8 4 3h11l2-7h-7v-6h15v15l-1 3-8 3-9 1-10-3-7-8-2-5v-12l4-8 5-4zM944 221h9l1 16 7-6 7-9 1-1h10l-6 8-8 10 2 4 13 18v1h-10l-11-14-1-3-5-1v18h-9zM553 221h27v6l-1 1h-17v10h14v6h-14v11h18v7h-27zM386 221h27v6l-1 1h-17v10h14v6h-14v11h17l1 1v6h-27zM987 221h26v7h-17v10h14v6l-2 1-12-1v11h17l1 1v5l-1 1h-26zM1072 220h8l8 4-2 6-12-2-3 2 1 4 14 7 3 5-1 9-4 5-8 3-10-2-5-3 1-5 3-2 6 3h7l2-7-10-3-6-4-2-4 1-9 4-5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1553 245h18l5 3 1 2v8l-2 3h-2l3 4v13h-4v-13h-14l-1 13h-4z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1019 221h9l8 13 2 4 8-15 2-2h9l-8 14-6 10-1 17h-8l-1-16-14-23zM817 221h33v6l-1 1h-11v34h-9v-34h-11l-1-1zM632 221h33v6l-1 1h-11v34h-9v-34h-11l-1-1zM346 221h32v7l-11 1v32l-1 1h-8v-34h-12zM422 221h9v34h16v7h-25z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M696 228h12l6 5 2 10-3 8-6 4h-11zM1512 245h17l5 4 1 2v7l-2 4-6 3h-12v13h-3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M896 221h9v34h16v7h-24zM455 221h8l1 34h15v7h-24z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1666 245h8l10 33-5-1-2-6-15-1-1 6-1 2-4-1z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M734 221h9v41h-9zM488 221h9v41h-9zM282 221h9v41h-9z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1449 245h8l11 29 1-29h4v33h-8l-8-20-3-10h-2v30h-3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1620 248h8l5 3 2 5v10l-3 7-3 2h-9z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1611 245h19l6 4 2 3v18l-3 5-5 3h-19v-3h5v-27h-5zm9 3v27h9l5-5 1-4v-10l-3-6-4-2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M800 221h8v41h-8z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1818 244h7l6 3 3 6v3h-4l-3-7-7-1-5 1v6l3 3 13 4 3 3v8l-5 5-3 1h-8l-6-3-2-4v-6h3l2 8 4 1h7l4-4-1-5-16-6-3-5 1-6 4-4zM1488 244h7l6 3 3 5v4h-4l-2-6-4-2-7 1-2 2v6l11 3 6 3 3 5-1 6-5 4-2 1h-8l-6-3-3-4v-6l4 1 2 6 3 2h7l4-3v-5l-18-8-1-2v-8l4-4zM1787 244h7l6 3 3 5v4h-4l-2-6-4-2-7 1-2 2v6l11 3 6 3 2 2v8l-5 5-3 1h-7l-6-3-3-4v-6h3l3 7 3 2h7l4-4-1-5-16-6-3-6 2-6 3-3zM1698 244h7l6 3 3 6v3h-4l-3-6-6-2-6 2-2 4v15l3 5 8 1 4-1 2-8h4l-2 9-4 3-3 1h-7l-6-3-3-4-1-4v-13l3-7 4-3zM1730 244h7l6 3 2 3 1 6h-4l-3-6-6-2-6 2-2 4v16l5 5h6l4-1 2-8h3v7l-5 5-3 1h-7l-6-3-3-4-1-4v-13l3-7 4-3zM1753 245h20v3l-16 1v10l15 1v3l-15 1-1 11h17l1 3h-21zM1585 245h20v3h-17v12h16v3h-16v12h17v3h-20z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1557 248h13l4 4-1 7-3 2h-13zM1516 248h11l4 4v6l-3 3h-13v-12z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1541 245h4v33h-4z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m1670 247 2 3 4 13v3h-12l2-9 3-9z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    d: "M1437 245h3v33h-3zM869 231l2 2 4 11v2h-11l3-10z"
  })));
};
export default SvgFlexipassSalto;